import { useCustom, useTranslation } from "@refinedev/core";
import { useAtomValue } from "jotai";
import { useGoogleApi } from "./useGoogleApi";
import { gql } from "graphql-tag";
import { ACCESS_TOKEN_QUERY_KEY, GAPI_POLLING_INTERVAL_MS } from "@auth/definitions";
import { apiJWTAtom } from "@auth/state";

export function useGoogleAccessToken() {
    const [gapi, _loading] = useGoogleApi()
    const { translate } = useTranslation();
    const authOk = useAtomValue(apiJWTAtom)

    const { data, ...rest } = useCustom({
        url: '',
        method: 'post',
        meta: {
            gqlQuery: gql`query GetToken {
            get_access_token {
                access_token
            }
          }`
        },
        errorNotification: (data, values) => {
            return {
                message: translate("common.google.no-integration"),
                description: "",
                type: "error",
            };
        },
        queryOptions: {
            //TODO: check a better way to do this without polling
            enabled: !_loading && !!authOk,
            staleTime: GAPI_POLLING_INTERVAL_MS,
            refetchInterval: GAPI_POLLING_INTERVAL_MS,
            queryKey: [ACCESS_TOKEN_QUERY_KEY],
        }
    })

    const newAccessToken = data?.data?.get_access_token?.access_token

    return { accessToken: newAccessToken, ...rest }
}